import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { ModalContent } from 'fronton-react';
import {
  CategoryCardHeader,
  CategoryCardMedia,
  CategoryCardWithGAClickButton,
  ModalHeader,
  SwiperSlide,
  SwiperWithNavigation,
  Typography,
} from 'common/components';
import { createElementKey } from 'utils';
import { analyticsUtils, ClickButtonElementName } from 'utils/analytics-utils';
import { STORAGE_ELEMENT_BLOCK } from '../../../../storage-constants';
import {
  STORAGE_ADDITIONAL_ITEM_LIST,
  StorageAdditionalItemStructure,
} from '../../../storage-additional-section';
import {
  allPurchasesModalContent,
  allPurchasesModalImage,
  allPurchasesModalSlide,
  allPurchasesModalSwiper,
  allPurchasesModalText,
  allPurchasesCategoryCard,
} from './all-purchases-modal-styles';

export const AllPurchasesModal = () => {
  const { t } = useTranslation();

  /**
   * Обработчик нажатия кнопки "Следующий слайд"
   */
  const handleNextSlideBtnClick = useCallback(() => {
    analyticsUtils.clickButtonEvent(
      STORAGE_ELEMENT_BLOCK,
      ClickButtonElementName.SwitchForward,
      t('utp-section.all-purchases.card-title')
    );
  }, [t]);

  /**
   * Обработчик нажатия кнопки "Предыдущий слайд"
   */
  const handlePrevSlideBtnClick = useCallback(() => {
    analyticsUtils.clickButtonEvent(
      STORAGE_ELEMENT_BLOCK,
      ClickButtonElementName.SwitchBackward,
      t('utp-section.all-purchases.card-title')
    );
  }, [t]);

  return (
    <>
      <ModalHeader title={t('utp-section.all-purchases.card-title')} />
      <ModalContent className={allPurchasesModalContent}>
        <Typography className={allPurchasesModalText} variant="m" size="body_long">
          {t('utp-section.all-purchases.modal-description')}
        </Typography>
        <SwiperWithNavigation
          className={allPurchasesModalSwiper}
          onSlideNextTransitionEnd={handleNextSlideBtnClick}
          onSlidePrevTransitionEnd={handlePrevSlideBtnClick}
          slidesPerView="auto"
          watchOverflow>
          {STORAGE_ADDITIONAL_ITEM_LIST.map(
            ({ name, imgSrc, link }: StorageAdditionalItemStructure, index: number) => (
              <SwiperSlide
                className={allPurchasesModalSlide}
                key={createElementKey('storage-add-item', index)}>
                <CategoryCardWithGAClickButton
                  className={allPurchasesCategoryCard}
                  elementBlock={STORAGE_ELEMENT_BLOCK}
                  elementName={t(name)}
                  elementText={t('utp-section.all-purchases.card-title')}
                  href={link.href}
                  title={t(link.title)}>
                  <CategoryCardHeader title={t(name)} />
                  <CategoryCardMedia
                    alt={t(name) || ''}
                    className={allPurchasesModalImage}
                    height={140}
                    src={imgSrc}
                    width={156}
                  />
                </CategoryCardWithGAClickButton>
              </SwiperSlide>
            )
          )}
        </SwiperWithNavigation>
      </ModalContent>
    </>
  );
};
